import { createSlice } from "@reduxjs/toolkit";
import {
  getSurveysAsync,
  getSurveyByIdAsync,
  getNextSurveysAsync,
} from "./actions";

const initialState = {
  isLoading: true,
  current: null,
  all: [],
  last: null,
  count: 0,
};

export const surveysSlice = createSlice({
  name: "surveys",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSurveysAsync.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getSurveysAsync.fulfilled, (state, action) => {
        state.all = action.payload.surveys;
        state.last = action.payload.last;
        state.count = action.payload.totalSurveysCount;
        state.isLoading = false;
      })
      .addCase(getSurveysAsync.rejected, (state, action) => {
        state.isLoading = false;
        state.all = [];
      })
      .addCase(getNextSurveysAsync.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getNextSurveysAsync.fulfilled, (state, action) => {
        state.all = [...state.all, ...action.payload.surveys];
        state.last = action.payload.last;
        state.isLoading = false;
      })
      .addCase(getNextSurveysAsync.rejected, (state, action) => {
        state.isLoading = false;
        state.all = [];
      })
      .addCase(getSurveyByIdAsync.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getSurveyByIdAsync.fulfilled, (state, action) => {
        state.current = action.payload;
        state.isLoading = false;
      })
      .addCase(getSurveyByIdAsync.rejected, (state, action) => {
        state.isLoading = false;
        state.current = null;
      });
  },
});

export default surveysSlice.reducer;
